const ArgumentType = require("../../extension-support/argument-type");
const BlockType = require("../../extension-support/block-type");
const formatMessage = require("format-message");
const AdapterBaseClient = require("../scratch3_eim/codelab_adapter_base.js");

const blockIconURI = 'data:image/png;base64,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';
const menuIconURI = blockIconURI;
/**
 * Enum for button parameter values.
 * @readonly
 * @enum {string}
 */

const NODE_ID = "eim/node_tello2";
const HELP_URL = "https://adapter.codelab.club/extension_guide/tello2/";

// 翻译
const FormHelp = {
    en: "help",
    "zh-cn": "帮助",
};

const FormSetEmitTimeout = {
    en: "set wait timeout [emit_timeout]s",
    "zh-cn": "设置等待超时时间[emit_timeout]秒",
};

const FormConnect = {
  en: "connect tello",
  "zh-cn": "连接tello",
};

const FormDisConnect = {
  en: "disconnect",
  "zh-cn": "断开连接",
};

const Form_control_node = {
  en: "[turn] [node_name]",
  "zh-cn": "[turn] [node_name]",
}

const FormTakeOff = {
  en: "takeoff",
  "zh-cn": "起飞",
}

const FormLand = {
  en: "land",
  "zh-cn": "降落",
}


const FormMoveCmd = {
  en: "fly [direction] [DISTANCE] cm",
  "zh-cn": "向[direction]飞行[DISTANCE]cm",
}


// Rotate x degree clockwise
const Form_rotate_clockwise = {
  en: "Rotate [CMD] degree [DEGREE] ",
  "zh-cn": "[CMD] 旋转 [DEGREE] 度",
}

const FormFlip = {
  en: "flip [DIRECTION]",
  "zh-cn": "向[DIRECTION]翻滚",
}

const FormGo = {
  en: "go x:[X] y:[Y] z:[Z] speed:[SPEED]",
  "zh-cn": "飞向 x:[X] y:[Y] z:[Z] 速度:[SPEED]",
}

const FormSetSpeed = {
  en: "set speed [SPEED]",
  "zh-cn": "设置速度 [SPEED]",
}

const Form_sendTopicMessageAndWait = {
  en: "broadcast [content] and wait",
  "zh-cn": "广播[content]并等待",
}

const Form_sendTopicMessageAndWait_REPORTER = {
  en: "broadcast [content] and wait",
  "zh-cn": "广播[content]并等待",
}

const FormEnableMissionPads = {
    en: "[action] mission pads",
    "zh-cn": "[action] 检测挑战卡",
  }

const FormGOMid = {
    en: "Fly to x[x] y[y] z[z] relative to the mission pad [mid] with [speed]",
    "zh-cn": "以[speed]速度飞往挑战卡[mid]位置x[x]y[y]z[z]",
  }

const  FormGetMid = {
    en: "find mission pad [mid]?",
    "zh-cn": "发现挑战卡[mid]?",
  }
  

class AdapterClient {
    onAdapterPluginMessage(msg) {
        this.node_id = msg.message.payload.node_id;
        if (this.node_id === this.NODE_ID) {
            // json 数据, class

            this.adapter_node_content_hat = msg.message.payload.content;
            this.adapter_node_content_reporter = msg.message.payload.content;
            console.log("content ->", msg.message.payload.content);
        }
    }

    constructor(node_id, help_url) {
        this.NODE_ID = node_id;
        this.HELP_URL = help_url;

        this.emit_timeout = 5000; //ms

        this.adapter_base_client = new AdapterBaseClient(
            null, // onConnect,
            null, // onDisconnect,
            null, // onMessage,
            this.onAdapterPluginMessage.bind(this), // onAdapterPluginMessage,
            null, // update_nodes_status,
            null, // node_statu_change_callback,
            null, // notify_callback,
            null, // error_message_callback,
            null // update_adapter_status
        );
    }

    emit_with_messageid(NODE_ID, content){
        return this.adapter_base_client.emit_with_messageid(NODE_ID,content,this.emit_timeout)
    }
}

class Scratch3TelloBlocks {
    constructor(runtime) {
        this.client = new AdapterClient(
            NODE_ID,
            HELP_URL,
            runtime,
            this
        );
    }

    /**
     * The key to load & store a target's test-related state.
     * @type {string}
     */
    static get STATE_KEY() {
        return "Scratch.tello2";
    }

    get CMDMENU_INFO() {
        return [
            {
                name: formatMessage({
                    id: "cxtello.cmdmenu.up",
                    default: "up",
                    description: "",
                }),
                value: "up",
            },
            {
                name: formatMessage({
                    id: "cxtello.cmdmenu.down",
                    default: "down",
                    description: "",
                }),
                value: "down",
            },
            {
                name: formatMessage({
                    id: "cxtello.cmdmenu.left",
                    default: "left",
                    description: "",
                }),
                value: "left",
            },
            {
                name: formatMessage({
                    id: "cxtello.cmdmenu.right",
                    default: "right",
                    description: "",
                }),
                value: "right",
            },
            {
                name: formatMessage({
                    id: "cxtello.cmdmenu.forward",
                    default: "forward",
                    description: "",
                }),
                value: "forward",
            },
            {
                name: formatMessage({
                    id: "cxtello.cmdmenu.back",
                    default: "back",
                    description: "",
                }),
                value: "back",
            },
        ];
    }

    get CWMENU_INFO() {
        return [
            {
                name: formatMessage({
                    id: "cxtello.cwmenu.cw",
                    default: "cw",
                    description: "",
                }),
                value: "cw",
            },
            {
                name: formatMessage({
                    id: "cxtello.cwmenu.ccw",
                    default: "ccw",
                    description: "",
                }),
                value: "ccw",
            },
        ];
    }

    get DIRECTIONMENU() {
        return [
            {
                name: formatMessage({
                    id: "cxtello.directionmenu.l",
                    default: "left",
                    description: "",
                }),
                value: "l",
            },
            {
                name: formatMessage({
                    id: "cxtello.directionmenu.r",
                    default: "right",
                    description: "",
                }),
                value: "r",
            },
            {
                name: formatMessage({
                    id: "cxtello.directionmenu.b",
                    default: "back",
                    description: "",
                }),
                value: "b",
            },
            {
                name: formatMessage({
                    id: "cxtello.directionmenu.f",
                    default: "forward",
                    description: "",
                }),
                value: "f",
            },
        ];
    }

    _buildMenu(info) {
        return info.map((entry, index) => {
            const obj = {};
            obj.text = entry.name;
            obj.value = entry.value || String(index + 1);
            return obj;
        });
    }

    _setLocale() {
        let now_locale = "";
        switch (formatMessage.setup().locale) {
            case "en":
                now_locale = "en";
                break;
            case "zh-cn":
                now_locale = "zh-cn";
                break;
            default:
                now_locale = "zh-cn";
                break;
        }
        return now_locale;
    }
    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo() {
        let the_locale = this._setLocale();
        return {
            id: "tello2",
            name: "tello2",
            colour: "#ff641d",
            colourSecondary: "#c94f18",
            colourTertiary: "#c94f18",
            menuIconURI: menuIconURI,
            blockIconURI: blockIconURI,
            blocks: [
                {
                    opcode: "open_help_url",
                    blockType: BlockType.COMMAND,
                    text: FormHelp[the_locale],
                    arguments: {},
                },
                {
                    opcode: "set_emit_timeout",
                    blockType: BlockType.COMMAND,
                    text: FormSetEmitTimeout[the_locale],
                    arguments: {
                        emit_timeout: {
                            type: ArgumentType.NUMBER,
                            defaultValue:5.0,
                        },
                    },
                },
                {
                  opcode: "control_node",
                  blockType: BlockType.COMMAND,
                  text: Form_control_node[the_locale],
                  arguments: {
                      turn: {
                          type: ArgumentType.STRING,
                          defaultValue: "start",
                          menu: "turn",
                      },
                      node_name: {
                          type: ArgumentType.STRING,
                          defaultValue: "node_tello2",
                      },
                  },
               },
                {
                    opcode: "connect",
                    blockType: BlockType.COMMAND,
                    text: FormConnect[the_locale]
                },
                {
                  opcode: "disconnect",
                  blockType: BlockType.COMMAND,
                  text: FormDisConnect[the_locale]
               },
                //FormDisConnect
                {
                    opcode: "takeoff",
                    blockType: BlockType.COMMAND,
                    text: FormTakeOff[the_locale]
                },
                {
                    opcode: "land",
                    blockType: BlockType.COMMAND,
                    text: FormLand[the_locale]
                },
                {
                    opcode: "movecmd",
                    blockType: BlockType.COMMAND,
                    text: FormMoveCmd[the_locale],
                    arguments: {
                        DISTANCE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 20,
                        },
                        direction: {
                            type: ArgumentType.STRING,
                            menu: "cmdmenu",
                            defaultValue: "up",
                        },
                    },
                },
                {
                    opcode: "rotate_clockwise",
                    blockType: BlockType.COMMAND,
                    text: Form_rotate_clockwise[the_locale],
                    arguments: {
                        DEGREE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 45
                        },
                        CMD: {
                            type: ArgumentType.STRING,
                            menu: "cwcmdmenu",
                            defaultValue: "cw",
                        },
                    },
                },
                {
                    opcode: "flip",
                    blockType: BlockType.COMMAND,
                    text: FormFlip[the_locale],
                    arguments: {
                        DIRECTION: {
                            type: ArgumentType.STRING,
                            menu: "directionmenu",
                            defaultValue: "l",
                        },
                    },
                },
                {
                    opcode: "go",
                    blockType: BlockType.COMMAND,
                    text: FormGo[the_locale],
                    arguments: {
                        X: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 20,
                        },
                        Y: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 20,
                        },
                        Z: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 20,
                        },
                        SPEED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10,
                        },
                    },
                },
                {
                    opcode: "setspeed",
                    blockType: BlockType.COMMAND,
                    text: FormSetSpeed[the_locale],
                    arguments: {
                        SPEED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10,
                        },
                    },
                },
                {
                    opcode: "enable_mission_pads",
                    blockType: BlockType.COMMAND,
                    text: FormEnableMissionPads[the_locale],
                    arguments: {
                        action: {
                            type: ArgumentType.STRING,
                            defaultValue: 'enable',
                            menu: 'mission_pads_action'
                        },
                    },
                },
                {
                    opcode: "get_mission_pad_id",
                    blockType: BlockType.BOOLEAN,
                    text: FormGetMid[the_locale],
                    arguments: {
                        mid: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1,
                            // menu: 'mission_pad_id'
                        },
                    },
                },
                //
                {
                    opcode: "go_xyz_speed_mid",
                    blockType: BlockType.COMMAND,
                    text: FormGOMid[the_locale],
                    arguments: {
                        x: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0,
                        },
                        y: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0,
                        },
                        z: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 50,
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 50,
                        },
                        mid: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1,
                        }
                    },
                },
                //
                {
                  opcode: "broadcastTopicMessageAndWait",
                  blockType: BlockType.COMMAND,
                  text: Form_sendTopicMessageAndWait[the_locale],
                  arguments: {
                      content: {
                          type: ArgumentType.STRING,
                          defaultValue: "tello.move_forward(20)",
                      },
                  },
              },
              {
                opcode: "broadcastTopicMessageAndWait_REPORTER",
                blockType: BlockType.REPORTER,
                text: Form_sendTopicMessageAndWait_REPORTER[the_locale],
                arguments: {
                    content: {
                        type: ArgumentType.STRING,
                        defaultValue: "tello.query_height()",
                    },
                },
              },
                /*
                {
                    opcode: "setwifi",
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.setwifi",
                            default: "set wifi:[WIFI] pass:[PASS]",
                            description: "setwifi",
                        }),
                        description: "setwifi",
                    }),
                    arguments: {
                        WIFI: {
                            type: ArgumentType.STRING,
                            defaultValue: "wifi",
                        },
                        PASS: {
                            type: ArgumentType.STRING,
                            defaultValue: "password",
                        },
                    },
                },*/
                /*
                {
                    opcode: "setrc",
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.setrc",
                            default:
                                "set roll:[A] pitch:[B] accelerator:[C] rotation:[D]",
                            description: "setrc",
                        }),
                        description: "setrc",
                    }),
                    arguments: {
                        A: {
                            type: ArgumentType.STRING,
                            defaultValue: "0",
                        },
                        B: {
                            type: ArgumentType.STRING,
                            defaultValue: "0",
                        },
                        C: {
                            type: ArgumentType.STRING,
                            defaultValue: "0",
                        },
                        D: {
                            type: ArgumentType.STRING,
                            defaultValue: "0",
                        },
                    },
                },
                */
                {
                  opcode: "getbattery",
                  blockType: BlockType.REPORTER,
                  text: formatMessage({
                      default: formatMessage({
                          id: "cxtello.actionMenu.getbattery",
                          default: "get battery",
                          description: "getbattery",
                      }),
                      description: "getbattery",
                  }),
                },
                {
                    opcode: "getspeed",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.getspeed",
                            default: "get speed",
                            description: "getspeed",
                        }),
                        description: "getspeed",
                    }),
                },
                {
                    opcode: "gettime",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.gettime",
                            default: "get time",
                            description: "gettime",
                        }),
                        description: "gettime",
                    }),
                },
                {
                    opcode: "getheight",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.getheight",
                            default: "get height",
                            description: "getheight",
                        }),
                        description: "getheight",
                    }),
                },
                {
                    opcode: "gettemp",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.gettemp",
                            default: "get temp",
                            description: "gettemp",
                        }),
                        description: "gettemp",
                    }),
                },
                {
                    opcode: "getattitude",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.getattitude",
                            default: "get attitude",
                            description: "getattitude",
                        }),
                        description: "getattitude",
                    }),
                },
                {
                    opcode: "getbaro",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.getbaro",
                            default: "get baro",
                            description: "getbaro",
                        }),
                        description: "getbaro",
                    }),
                },
                /*
                {
                    opcode: "getacceleration",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.getacceleration",
                            default: "get acceleration",
                            description: "getacceleration",
                        }),
                        description: "getacceleration",
                    }),
                },*/
                {
                    opcode: "gettof",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.gettof",
                            default: "get tof",
                            description: "gettof",
                        }),
                        description: "gettof",
                    }),
                },
                {
                    opcode: "getwifi",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        default: formatMessage({
                            id: "cxtello.actionMenu.getwifi",
                            default: "get wifi",
                            description: "getwifi",
                        }),
                        description: "getwifi",
                    }),
                },
            ],
            menus: {
                cmdmenu: {
                    acceptReporters: true,
                    items: this._buildMenu(this.CMDMENU_INFO),
                },
                cwcmdmenu: {
                    acceptReporters: true,
                    items: this._buildMenu(this.CWMENU_INFO),
                },
                directionmenu: {
                    acceptReporters: true,
                    items: this._buildMenu(this.DIRECTIONMENU),
                },
                turn: {
                    acceptReporters: true,
                    items: ["start", "stop"],
                },
                mission_pads_action: {
                    items: ["enable", "disable"],
                },
                
            },
        };
    }

    connect(args, util) {
        const content = "tello.connect()";
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }

    disconnect(args, util) {
      const content = "tello.__del__()";
      return this.client.emit_with_messageid(
          NODE_ID,
          content
      );
    }

    

    takeoff(args, util) {
        const content = "tello.takeoff()";
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }

    land(args, util) {
        const content = "tello.land()";
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }


    movecmd(args, util) {
        const direction = args.direction;
        const DISTANCE = parseFloat(args.DISTANCE);
        const content = `tello.move_${direction}(${DISTANCE})`;
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }

    rotate_clockwise(args, util) {
      const  _map = {
        "cw": "rotate_clockwise",
        "ccw": "rotate_counter_clockwise",
      };
      const  action = _map[args.CMD];
      const  DEGREE = parseFloat(args.DEGREE);
      const  content = `tello.${action}(${DEGREE})`;
      return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }

    flip(args, util) {
        const  DIRECTION = args.DIRECTION;
        const  content = `tello.flip("${DIRECTION}")`;
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }

    go(args, util) {
        const content = `tello.go_xyz_speed(${args.X}, ${args.Y}, ${args.Z}, ${args.SPEED})`;
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }

    setspeed(args, util) {
        const SPEED = parseFloat(args.SPEED);
        const content = `tello.set_speed(${SPEED})`;
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }

    enable_mission_pads(args) {
        const action = args.action;
        const _map = {
            "enable": `tello.enable_mission_pads()`,
            "disable": `tello.disable_mission_pads()`
        }
        const content = _map[action];
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }

    get_mission_pad_id(args){
        const mid = args.mid; //string
        const content = `tello.get_mission_pad_id()`;
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        ).then(data => {
            return (data===mid)
          });
    }

    async go_xyz_speed_mid(args) {
        /*
        go_xyz_speed_mid(self, x: int, y: int, z: int, speed: int, mid: int):
        */
        const x = parseFloat(args.x);
        const y = parseFloat(args.y);
        const z = parseFloat(args.z);
        const speed = parseFloat(args.speed);
        const mid = parseFloat(args.mid);
        
        const content = `tello.go_xyz_speed_mid(${x},${y},${z},${speed},${mid})`;
        return this.client.emit_with_messageid(
            NODE_ID,
            content
        );
    }
    // broadcast
    broadcastTopicMessageAndWait(args) {
      const node_id = args.node_id;
      const content = args.content;
      return this.client.emit_with_messageid(node_id, content);
  }

    getspeed() {
        return this.client.emit_with_messageid(
            NODE_ID,
            "tello.query_speed()"
        );
    }

    getbattery() {
        return this.client.emit_with_messageid(
            NODE_ID,
            "tello.get_battery()"
        );
    }

    gettime() {
        return this.client.emit_with_messageid(
            NODE_ID,
            "tello.get_flight_time()"
        );
    }

    getheight() {
        return this.client.emit_with_messageid(
            NODE_ID,
            "tello.get_height()"
        );
    }

    gettemp() {
        return this.client.emit_with_messageid(
            NODE_ID,
            "tello.query_temperature()"
        );
    }

    getattitude() {
        return this.client.emit_with_messageid(
            NODE_ID,
            "tello.query_attitude()"
        );
    }

    getbaro() {
        return this.client.emit_with_messageid(
            NODE_ID,
            "tello.query_barometer()"
        );
    }

    gettof() {
        return this.client.emit_with_messageid(
            NODE_ID,
            "tello.get_distance_tof()"
        );
    }

    getwifi() {
        return this.client.emit_with_messageid(
            NODE_ID,
            "tello.query_wifi_signal_noise_ratio()"
        );
    }

    open_help_url(args) {
        window.open(HELP_URL);
    }


    control_node(args) {
      const content = args.turn;
      const node_name = args.node_name;
      return this.client.adapter_base_client.emit_with_messageid_for_control(
          NODE_ID,
          content,
          node_name,
          "node"
      );
    }

    set_emit_timeout(args) {
        const timeout = parseFloat(args.emit_timeout) * 1000;
        this.client.emit_timeout = timeout;
    }

    broadcastTopicMessageAndWait(args) {
      // topic服务于消息功能， node_id承载业务逻辑(extension)
      const content = args.content;
      return this.client.adapter_base_client.emit_with_messageid(NODE_ID, content);
  }

  broadcastTopicMessageAndWait_REPORTER(args) {
      // topic服务于消息功能， node_id承载业务逻辑(extension)
      const content = args.content;
      return this.client.adapter_base_client.emit_with_messageid(NODE_ID, content);
  }

}

module.exports = Scratch3TelloBlocks;
